export class UserPreferences {
  constructor() {
    // Get user preferences from local storage.
    this.preferences = localStorage.getItem('lotuscrafts-user-preferences') || '{}';
    this.preferences = JSON.parse(this.preferences);

    // Apply preferences.

    if (this.preferences.snowflakesDisabled) {
      document.dispatchEvent(
        new CustomEvent('user-preferences.snowflakes-disabled', {
          detail: { data: { snowflakesDisabled: this.preferences.snowflakesDisabled } },
        }),
      );

      document
        .querySelector('c-toggle[data-action="toggle-snowflakes"] input')
        .setAttribute('checked', '');
    }

    // Add event listeners.
    this.addEventListeners();
  }

  addEventListeners() {
    // Snowflakes toggle. Checked state means the snowflakes are disabled.

    document.addEventListener('c-toggle.input.toggle-snowflakes', (event) => {
      // Checked in this case means the snowflakes are disabled.

      const { checked } = event.detail;

      this.setPreference('snowflakesDisabled', checked);
    });
  }

  getPreference(key) {
    return this.preferences[key];
  }

  setPreference(key, value) {
    this.preferences[key] = value;

    localStorage.setItem('lotuscrafts-user-preferences', JSON.stringify(this.preferences));
  }
}
